import {
  ChatAvailabilityResult,
  ChatAvailabilityResultTypenames,
} from '@varo/graphql-schema-types';
import { useEffect, useState } from 'react';
import ChatAvailability from 'services/graphql/queries/ChatAvailability.query';
import { useQuery } from 'urql';

const useChatAvailability = () => {
  const [result, reExecuteQuery] = useQuery<{
    chatAvailability: ChatAvailabilityResult;
  }>({
    query: ChatAvailability,
    requestPolicy: 'network-only',
    pause: true,
  });
  const { data, fetching, error } = result;

  useEffect(() => {
    reExecuteQuery({ requestPolicy: 'network-only' });
  }, [reExecuteQuery]);

  const [chatAvailability, setChatAvailability] =
    useState<ChatAvailabilityResult>();

  useEffect(() => {
    if (data) {
      if (
        data.chatAvailability.__typename ===
        ChatAvailabilityResultTypenames.ChatAvailabilityBusy
      ) {
        setChatAvailability({
          __typename: ChatAvailabilityResultTypenames.ChatAvailabilitySuccess,
          message: '',
        });
      } else {
        setChatAvailability(data.chatAvailability);
      }
    }
  }, [data]);

  return {
    chatAvailabilityFetching: fetching,
    error,
    chatAvailability,
    reExecuteQuery,
  };
};

export default useChatAvailability;
